<template>
  <div>
    <component :is="pagefooterversion" />
  </div>
</template>

<script>

export default {
  name: 'page-bottom',
  asyncComponents: (app) => {
    let version = app.registry.getModuleSetting('theme', 'page-footer', '0001')
    return [ `page-footer-${version}` ]
  },
  computed: {
    pagefooterversion() {
      let version = this.$store.getters['getModuleSetting']('theme', 'page-footer', '0001')
      return `page-footer-${version}`
    }
  }
}
</script>
